import io from 'socket.io-client';

class Socket {
  static client = io(process.env.VUE_APP_DASHBOARD_SERVER, {
    transports: ['websocket', 'polling']
  });
}

export default Socket;
